import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import { Tooltip } from 'react-tooltip'
import { PencilIcon, SearchIcon } from '@primer/octicons-react'
import { BiHelpCircle } from "react-icons/bi";
import LocPickerDialog from './LocPickerDialog';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const DatapointAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [datapointAttrs, setDatapointAttrs] = useState({
    id: '',
    code: '',
    description: '',
    typeId: '',
    datasourceId: '',
    externalSystemId: '',
    externalSystemId2: '',
    assetCode: '',
    locationId: '',
    location: '',
    creatorUsername: '',
    timeCreated: '',
    updaterUsername: '',
    timeUpdated: ''
  });

  const [currentDatapointAttrs, setCurrentDatapointAttrs] = useState({});

  const [datapointTypeList, setDatapointTypeList] = useState([]);
  const [datasourceList,    setDatasourceList]    = useState([]);
  const [dataTypeOptions,   setDataTypeOptions]   = useState([]);
  const [unitOptions,       setUnitOptions]       = useState([]);

  const [showLocPickerDialog, setShowLocPickerDialog] = useState(false);

  /* ##### Future enhancement #####
  const statusOptions = [
    { key: "ACTIVE",    value: "ACTIVE" },
    { key: "DISABLED",  value: "DISABLED" }
  ];
  */


  // UI Functions

  // Initialize state
  useEffect(() => {
    if (props) {
      setDatapointAttrs(props.objDetails);
      setCurrentDatapointAttrs(props.objDetails);
    }

    fetchDatapointTypes();
    fetchDatasources();
    fetchDataTypes();
    fetchUnits();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const fetchDatapointTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("datapoint-types");

        resolve(res.data);

        if (res.status === 200) {
          setDatapointTypeList(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  const fetchDatasources = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("datasources");

        resolve(res.data);

        if (res.status === 200) {
          setDatasourceList(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  const fetchDataTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("tr-data-types");

        resolve(res.data);

        if (res.status === 200) {
          setDataTypeOptions(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  const fetchUnits = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("tr-units");

        resolve(res.data);

        if (res.status === 200) {
          setUnitOptions(res.data);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg,             setErrMsg]             = useState('');
  const [errMsg_Update,      setErrMsg_Update]      = useState('');
  //const [errMsg_InspectData, setErrMsg_InspectData] = useState('');

  //const [datapointDataList, setDatapointDataList] = useState([]);
  //const [showInspectDataDialog, setShowInspectDataDialog] = useState(false);

  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setDatapointAttrs({ ...datapointAttrs, [e.target.name]: e.target.value })
  }

  const onDatapointTypeClick = (datapointTypeId, event) => {

    // Update attributes inherited from datasource type
    const datapointType = datapointTypeList.find( ({ id }) => id.toString() === datapointTypeId.toString());

    // Make a deep copy
    let newDatapointAttrs = JSON.parse(JSON.stringify(datapointAttrs));
    newDatapointAttrs.typeId     = datapointType.id;
    newDatapointAttrs.type       = datapointType.code;
    newDatapointAttrs.datatype   = datapointType.datatype;
    newDatapointAttrs.unit       = datapointType.unit;

    setDatapointAttrs (newDatapointAttrs);
  };

/*
  const onDatasourceSelect = (key, event) => {
    let datasourceCode = (datasourceList.find( ({ id }) => id === parseInt(key) )).code;

    let newDatapointAttr = JSON.parse (JSON.stringify(datapointAttrs));
    newDatapointAttr.datasource   = datasourceCode;
    newDatapointAttr.datasourceId = key;

    setDatapointAttrs(newDatapointAttr);
  };
*/

  const onDatasourceClick = (datasourceId, event) => {
    let datasourceCode = (datasourceList.find( ({ id }) => id.toString() === datasourceId.toString())).code;

    let newDatapointAttr = JSON.parse (JSON.stringify(datapointAttrs));
    newDatapointAttr.datasource   = datasourceCode;
    newDatapointAttr.datasourceId = datasourceId;

    setDatapointAttrs(newDatapointAttr);
  };

  /* ##### Future enhancement ##### 
  const onStatusClick = (key, event) => {

    setDatapointAttrs({ ...datapointAttrs, status: key })
  };
  */


  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setDatapointAttrs(currentDatapointAttrs);

    setEditMode(false);
    setErrMsg_Update('');
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (datapointAttrs.code.trim().length === 0) {
      setErrMsg_Update(t("I18N_ERR_Need_datapoint_code"));
    } else if (!datapointAttrs.description || (datapointAttrs.description.trim().length === 0)) {
      setErrMsg_Update(t("I18N_ERR_Need_description"));
    } else if (datapointAttrs.typeId === '') {
      setErrMsg_Update(t("I18N_ERR_Need_dpType"));
    } else if (datapointAttrs.datasourceId === '') {
      setErrMsg_Update(t("I18N_ERR_Need_datasource"));
    } else if ((datapointAttrs.code != null) && (datapointAttrs.code.length > 100)) {
      setErrMsg_Update(t("I18N_ERR_Max_len_code") + 100);
    } else if ((datapointAttrs.description != null) && (datapointAttrs.description.length > 200)) {
      setErrMsg_Update(t("I18N_ERR_Max_len_desc") + 200);
    } else if ((datapointAttrs.externalSystemId != null) && (datapointAttrs.externalSystemId.length > 100)) {
      setErrMsg_Update(t("I18N_ERR_Max_len_ext_sys_id") + 100);
    } else if ((datapointAttrs.externalSystemId2 != null) && (datapointAttrs.externalSystemId2.length > 100)) {
      setErrMsg_Update(t("I18N_ERR_Max_len_ext_sys_id2") + 100);
    } else if ((datapointAttrs.assetCode != null) && (datapointAttrs.assetCode.length > 50)) {
      setErrMsg_Update(t("I18N_ERR_Max_len_asset_code") + 50);
    } else {
      setErrMsg_Update('');
      updateDatapoint();
    }
  }

  const updateDatapoint = () => {

    const reqBody = datapointAttrs;

    if (reqBody.location === '') {
      reqBody.location = '';
      reqBody.locationId = '';
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.put("datapoints/" + datapointAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          refreshDatapointAttrs(datapointAttrs.id);

          // Restore UI to viewing mode
          setEditMode(false);

          setErrMsg_Update('');
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_Update(t(translateAPIError(error)));
        }
      }
    });

  }


  const refreshDatapointAttrs = (datapointId) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("datapoints/" + datapointId);

        resolve(res.data);

        if (res.status === 200) {

          setDatapointAttrs(res.data[0]);
          setCurrentDatapointAttrs(res.data[0]);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }

/*
  const fetcDatapointData = () => {

    return new Promise(async (resolve, reject) => {
      try {
        // #### TEMP HACK.  NEED TO PROVIDE WAYS TO SELECT TIME RANGE #####
        const res = await axiosAuth_DATA_MGMT_API.get("datapoint-data-inspect/" + datapointAttrs.code);

        resolve(res.data);

        if (res.status === 200) {
          setDatapointDataList(res.data);
        }

        setErrMsg_InspectData('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_InspectData(t(translateAPIError(error)));
        }
      }
    });
  }
*/


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


/*
  const handleInspectData = (e) => {
    //e.preventDefault();
    fetcDatapointData();
    setShowInspectDataDialog(true);
  }

  const handleInspectDataClose = () => {
    setShowInspectDataDialog(false);
  }

  function renderDatapointData(datapointData, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td>{datapointData.value}</td>
        <td>{datapointAttrs.unit}</td>
        <td>{formatDate((new Date(0)).setUTCSeconds(datapointData.timeStamp))}</td>
      </tr>
    )
  }
*/


  // Location select dialog stuff

  const handleLocPicker = (e) => {
    setShowLocPickerDialog(true);
  }

  function handleLocPickerClose() {
    setShowLocPickerDialog(false);
  }

  function handleLocSelect(location) {
/* ##### If I do this, the locationId is NOT set.  Why??? #####
    setDatapointAttrs({ ...datapointAttrs, locationId: location.id });
    setDatapointAttrs({ ...datapointAttrs, location:   location.code });
*/
    // Deep copy
    let newDatapointAttr = JSON.parse (JSON.stringify(datapointAttrs));
    newDatapointAttr.locationId = location.id;
    newDatapointAttr.location   = location.code;

    setDatapointAttrs(newDatapointAttr);

    setShowLocPickerDialog(false);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', height:'600px', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Datapoint_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Datapoint_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Datapoint_code")}: *</Col>
                  <Col>{t("I18N_Description")}:</Col>
                  <Col>
                    <span>{t("I18N_Ext_sys_id")}:</span>
                    <span style={{marginLeft:'5px'}} data-tooltip-id="ext-sys-id-tip" data-tooltip-html={t("I18N_TIP_Ext_sys_id")} >
                       <BiHelpCircle size={14} />
                    </span>
                    <Tooltip id="ext-sys-id-tip" />
                  </Col>
                  <Col>{t("I18N_Ext_sys_id2")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="code" value={datapointAttrs.code}
                              onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description" value={datapointAttrs.description}
                              onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="externalSystemId" value={datapointAttrs.externalSystemId}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="externalSystemId2" value={datapointAttrs.externalSystemId2}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Datapoint_type_code")}: *</Col>
                  <Col>{t("I18N_Datasource")}: *</Col>
                  <Col>{t("I18N_Asset_code")}:</Col>
                  <Col>{t("I18N_Location_code")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <Dropdown>
                      <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                        {!datapointAttrs.typeId ? t("common:I18N_DROPDOWN_PROMPT") :
                           (datapointTypeList.find( ({ id }) => id === parseInt(datapointAttrs.typeId) )).code}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                        {datapointTypeList.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onDatapointTypeClick(item.id)}>
                              {item.code}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>

                  </Col>
                  <Col>
{/*
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!datapointAttrs.datasourceId ? t("common:I18N_DROPDOWN_PROMPT") :
                              (datasourceList.find( ({ id }) => id === parseInt(datapointAttrs.datasourceId) )).code}
                      onSelect={onDatasourceSelect}>
                      {datasourceList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap}>
                            {item.code}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
*/}
                    <Dropdown>
                      <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                        {!datapointAttrs.datasourceId ? t("common:I18N_DROPDOWN_PROMPT") :
                           (datasourceList.find( ({ id }) => id === parseInt(datapointAttrs.datasourceId) )).code}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                        {datasourceList.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onDatasourceClick(item.id)}>
                              {item.code}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="assetCode" value={datapointAttrs.assetCode}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col>
                    <input readOnly className={classes.admin_pages__field_editable} style={{width:'80%'}} name="location" value={datapointAttrs.location}
                      onChange={(e) => onAttrsInputChange(e)} />
                    <span onClick={handleLocPicker} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <SearchIcon size={14} />
                    </span>
                  </Col>
                </Row>

                {/* ##### Future enhancement #####
                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col>{t("I18N_Status")}:</Col>
                  <Col></Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <Dropdown>
                      <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button">
                        {!datapointAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") : datapointAttrs.status}
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{ maxHeight: "300px", overflowY: "auto"}} id="dropdown-basic-button" >
                        {statusOptions.map((item, index) => {
                          return (
                            <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onStatusClick(item.key)}>
                              {item.value}
                            </Dropdown.Item>
                          );
                        })}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                  <Col></Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                */}

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg_Update}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Datapoint_code")}:</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col>
                  <span>{t("I18N_Ext_sys_id")}:</span>
                  <span style={{marginLeft:'5px'}} data-tooltip-id="ext-sys-id-tip" data-tooltip-html={t("I18N_TIP_Ext_sys_id")} >
                     <BiHelpCircle size={14} />
                  </span>
                  <Tooltip id="ext-sys-id-tip" />
                </Col>
                <Col>{t("I18N_Ext_sys_id2")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{datapointAttrs.code}</Col>
                <Col>{datapointAttrs.description}</Col>
                <Col>{datapointAttrs.externalSystemId  ? datapointAttrs.externalSystemId  : '--' }</Col>
                <Col>{datapointAttrs.externalSystemId2 ? datapointAttrs.externalSystemId2 : '--' }</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Datapoint_type")}:</Col>
                <Col>{t("I18N_Datasource")}:</Col>
                <Col>{t("I18N_Data_type")}:</Col>
                <Col>{t("I18N_Unit")}: </Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{datapointAttrs.type}</Col>
                <Col>
                  {(datasourceList.find( ({ code }) => code === datapointAttrs.datasource )) ?
                   (datasourceList.find( ({ code }) => code === datapointAttrs.datasource )).code : ''}
                </Col>
                <Col>
                  {(dataTypeOptions.find( ({ code }) => code === datapointAttrs.dataType )) ?
                   (dataTypeOptions.find( ({ code }) => code === datapointAttrs.dataType )).code : ''}
                </Col>
                <Col>
                  {(unitOptions.find( ({ code }) => code === datapointAttrs.unit )) ?
                   (unitOptions.find( ({ code }) => code === datapointAttrs.unit )).symbol : ''}
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Asset_code")}:</Col>
                <Col>{t("I18N_Location_code")}:</Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{datapointAttrs.assetCode ? datapointAttrs.assetCode : '--' }</Col>
                <Col>{datapointAttrs.location  ? datapointAttrs.location  : '--' }</Col>
                <Col></Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{datapointAttrs.creatorUsername}</Col>
                <Col>{formatDate(datapointAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{datapointAttrs.updaterUsername}</Col>
                <Col>{formatDate(datapointAttrs.timeUpdated)}</Col>
              </Row>

              {/* ##### Future enhancement #####
              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Status")}:</Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{t("I18N_ST_" + datapointAttrs.status)}</Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </Row>
              */}
            </Container>
          }
        </div>


        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
{/*
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '0px', fontSize: '12px', fontWeight: '300' }}
                onClick={handleInspectData}>
                {t("I18N_Inspect_data")}
              </Button>
*/}
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '0px', fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top', marginLeft: '10px' }}>
                {errMsg}
              </span>
            </div>
          </Form.Group>
        </div>


        <LocPickerDialog
          show={showLocPickerDialog}
          handleObjSelect={handleLocSelect}
          onClose={handleLocPickerClose}
        />

      </Card>
    </>
  );
}

export default DatapointAdminDetailsView;
